import { type SelectOption, Select } from '@/shared/ui/select';

import { Site, SiteV3 } from '../../api/types';

import convertToOptions from './lib/convertToOptions';

export interface ISiteSelect {
  current: number[];
  onChange: (data: SelectOption[]) => void;
  data:
    | Pick<Site, 'id' | 'url'>[]
    | Pick<SiteV3, 'id' | 'domain'>[]
    | undefined;
  disabled?: boolean;
}

export default function SiteSelect({
  current,
  onChange,
  data,
  disabled,
}: ISiteSelect) {
  const sites = data ? convertToOptions(data) : [];
  const convertedCurrent = sites.filter((site) => current.includes(site.value));

  return (
    <Select
      type="multi"
      withSearch
      current={convertedCurrent}
      multiplyLabel="Sites"
      onChange={onChange}
      options={sites}
      disabled={disabled}
    />
  );
}
